// Auth types constants
export const AUTH_TYPES = {
  INTERNAL: 'INTERNAL', // Внутренняя авторизация (Login/Password)
  MOBILE: 'MOBILE', // Внутренняя авторизация по моб. телефону (Phone/Password)
  LDAP: 'LDAP',
  OAUTH: 'OAUTH', // Внешняя авторизация OAUTH (пример вход через: google, yandex, etc.)
  SAP: 'SAP',
};

// Auth routes constants
export const AUTH_ROUTE = {
  auth: {
    INTERNAL: '/user-login/auth',
    MOBILE: '/user-login/mobile',
  },
  recover: {
    INTERNAL: '/user-login/recovery',
    MOBILE: '/user-login/mobile-recovery',
  },
  registr: {
    INTERNAL: '/user-login/registration',
    MOBILE: '/user-login/mobile-registration',
  },
};

// Default export for backward compatibility
export default {
  AUTH_TYPES,
  AUTH_ROUTE,
};
